"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = exports.IFRAMEID = exports.InteractionModes = void 0;
/**
 * Interaction mode specification available here:
 * https://bitbucket.klarna-static.net/pages/PAPI/partner-apis/main/browse/docs/typedoc/klarna.js/enumerations/enumeration.FlowInteractionMode
 */
var InteractionModes;
(function (InteractionModes) {
    InteractionModes["DEVICE_BEST"] = "DEVICE_BEST";
    InteractionModes["ON_PAGE"] = "ON_PAGE";
    InteractionModes["IFRAME"] = "IFRAME";
    InteractionModes["REDIRECT"] = "REDIRECT";
})(InteractionModes || (exports.InteractionModes = InteractionModes = {}));
exports.IFRAMEID = 'klarna-flow-interaction-mode-iframe';
var Device;
(function (Device) {
    Device["MOBILE"] = "MOBILE";
    Device["DESKTOP"] = "DESKTOP";
    Device["WEBVIEW"] = "WEBVIEW";
    Device["UNKNOWN"] = "UNKNOWN";
})(Device || (exports.Device = Device = {}));
